
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/[speciali]/all",
      function () {
        return require("private-next-pages/s/[speciali]/all.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/[speciali]/all"])
      });
    }
  